export enum EConactAddressType {
  AS_PROJECT = 'same-as-project',
  OTHER = 'other',
}
